import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import AccountMenu from '../../Modules/AccountMenu'

class MemberDocentschapOverviewAdd extends Component {
    render() {
        const wellStyles = { maxWidth: 400, margin: '0 auto 10px' };

        return (
            <div className="route">
                <AccountMenu />
                <div className="grey-bg">
                    <h1 className="pageTitle">
                        Docentschap toevoegen overzicht
            </h1>
                    <p>Op deze webpagina kunt u uw permanente educatie activiteiten invullen.</p>
                    <p>Bij bekende opleidingen en cursussen kunt u selecteren uit het opleidingen- en cursussenbestand van het Constructeursregister. U krijgt dan direct het aantal kenniseenheden te zien. Definitieve toewijzing van de kenniseenheden vindt plaats na beoordeling door de toetsingscommissie. Klik hier voor de toelichting..</p>
                    <hr />
                    <Row>
                        <Col md={6} sm={6}>
                            <div className="well" style={wellStyles}>
                                <LinkContainer to="/kennis/docentschap/toevoegen/docentschap"><Button bsSize="large" block>Docentschap</Button></LinkContainer>
                                <LinkContainer to="/kennis/docentschap/toevoegen/afstudeerbegeleiding"><Button bsSize="large" block>Afstudeerbegeleiding</Button></LinkContainer>
                            </div>
                        </Col>
                        <Col md={6} sm={6}>
                            <div className="well" style={wellStyles}>
                                <LinkContainer to="/kennis/docentschap/toevoegen/gastcollege"><Button bsSize="large" block>Gastcollege</Button></LinkContainer>
                                <LinkContainer to="/kennis/docentschap/toevoegen/examinator"><Button bsSize="large" block>Examinator</Button></LinkContainer>
                            </div>
                        </Col>
                    </Row>
                    {/* <Bijeenkomst /> */}
                </div>
            </div>
        );
    }
}

export default MemberDocentschapOverviewAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/Docentschap.js